import React, { useState } from 'react';
import { TextField, Autocomplete, Typography, Box, Grid } from '@mui/material';
import BaseModal from './BaseModal';

const TrainerWiseModal = ({ open, onClose, onSubmit, loading, reportType, trainingTypes }) => {
  const [filters, setFilters] = useState({
    dateRange: {
      startDate: null,
      endDate: null,
    },
    trainingType: null,
  });

  const handleTrainingTypeChange = (event, value) => {
    setFilters((prev) => ({ ...prev, trainingType: value }));
  };

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [field]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const payload = {
      trainingTypeName: filters.trainingType?.trainingName,
      startDate: filters.dateRange.startDate,
      endDate: filters.dateRange.endDate,
    };

    onSubmit(payload);
  };

  const handleClose = () => {
    setFilters({
      dateRange: {
        startDate: null,
        endDate: null,
      },
      trainingType: null,
    });
    onClose();
  };

  const isSubmitDisabled =
    !filters.dateRange.startDate || !filters.dateRange.endDate || !filters.trainingType;

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      loading={loading}
      reportType={reportType}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
          Select Filters
        </Typography>

        <Grid container spacing={3}>
          {/* Training Type */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Training Type *
            </Typography>
            <Autocomplete
              options={trainingTypes || []}
              getOptionLabel={(option) => option.trainingName || ''}
              value={filters.trainingType}
              onChange={handleTrainingTypeChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select training type"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>

          {/* Date Range */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Start Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.startDate || ''}
              onChange={(e) => handleDateChange('startDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              End Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.endDate || ''}
              onChange={(e) => handleDateChange('endDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default TrainerWiseModal;
